import type { TranslatedString } from '@interfaces/shared';
import InfoDialog from '@ovComponents/2-component/infoDialog/infoDialog';
import { Box, Divider, Typography } from 'hephaestus/web';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useLocalization } from '../../hooks/useLocalization';

export type DisclaimerProp = {
  options: {
    contentDescriptionBanner: TranslatedString;
    contentDescriptionTitle: TranslatedString;
    contentDescription: TranslatedString;
  };
};

export const Disclaimer = ({ options }: DisclaimerProp) => {
  const { translateBackendString } = useLocalization();

  if (
    !options?.contentDescriptionBanner &&
    !options?.contentDescriptionTitle &&
    !options?.contentDescription
  )
    return null;

  return (
    <>
      <Box
        sx={{
          py: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
          <ReactMarkdown
            className='markdown'
            remarkPlugins={[remarkGfm]}
            linkTarget='_blank'
          >
            {translateBackendString(options.contentDescriptionBanner)}
          </ReactMarkdown>
        </Typography>
        <InfoDialog
          title={translateBackendString(options.contentDescriptionTitle)}
          information={translateBackendString(options.contentDescription)}
          dialogSx={{
            '.MuiDialog-container': {
              alignItems: 'flex-start',
              paddingTop: 2,
              '.MuiDialogTitle-root': { border: 'none' },
              '.MuiDialogContent-root': {
                paddingTop: '0 !important',
                '.MuiTypography-root': { m: 0, pb: 2 },
              },
            },
          }}
          center
        />
      </Box>
      <Divider />
    </>
  );
};
